import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { GlobalSearchIndexDTO } from '../core/models';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  /**
   * Búsqueda rápida global (OpenAPI: GET /global-search?query=).
   */
  search(query: string): Observable<GlobalSearchIndexDTO[]> {
    const params = new HttpParams().set('query', query);
    return this.http.get<GlobalSearchIndexDTO[]>(`${this.apiUrl}/global-search`, { params });
  }
}
